import * as React from "react";
// import { WEBSITE } from "../intl/copyright";
// import { useSelector } from "react-redux";

import Features from "../containers/Features/Features.Website";
// import HeroImage from "../assets/images/hero/hero.webp";
// import Hero from "../components/Section/Section.Hero";
import JoinUs from "../containers/JoinUs";
import Layout from "../components/Layout";
import Seo from "../components/Seo/Seo";
import HeroWave from "../components/Section/Section.HeroWave";

const Website = () => {
  // const { lang } = useSelector((state) => state.appReducer);
  // const copy = WEBSITE[lang];

  return (
    <Layout>
      <HeroWave />
      {/* <Hero t2={copy.t2} t3={copy.t3} image={HeroImage} /> */}
      <Features />
      <JoinUs />
    </Layout>
  );
};

export default Website;

export const Head = () => {
  const TITLE = {
    pt: "Home",
    uk: "Home",
    es: "Casa",
  };

  return <Seo title={TITLE} />;
};
